import {
  Component,
  ChangeDetectorRef
} from '@angular/core';

import { CommonModule } from '@angular/common';

import {
  FormBuilder,
  FormGroup,
  Validators,
  ReactiveFormsModule
} from '@angular/forms';

import {
  HttpErrorResponse
} from '@angular/common/http';

import {
  Router,
  RouterModule
} from '@angular/router';

import { finalize } from 'rxjs';

import {
  RecaptchaModule
} from 'ng-recaptcha';

import {
  AuthService,
  LoginRequest
} from '../../../../core/services/auth.service';

@Component({
  selector: 'app-login',

  standalone: true,

  imports: [
    CommonModule,
    ReactiveFormsModule,
    RouterModule,
    RecaptchaModule
  ],

  templateUrl: './login.component.html',

  styleUrls: ['./login.component.scss']
})
export class LoginComponent {

  loading = false;

  errorMessage = '';

  showPassword = false;

  captchaToken: string | null = null;

  form: FormGroup;

  constructor(

    private fb: FormBuilder,

    private authService: AuthService,

    private router: Router,

    private cdr: ChangeDetectorRef

  ) {

    this.form = this.fb.group({

      email: [
        '',
        [
          Validators.required,
          Validators.email
        ]
      ],

      password: [
        '',
        [
          Validators.required
        ]
      ]

    });

  }

  togglePassword(): void {

    this.showPassword =
      !this.showPassword;

  }

  onCaptchaResolved(
    token: string | null
  ): void {

    this.captchaToken = token;

  }

  login(): void {

    if (this.form.invalid) {

      this.errorMessage =
        'Preencha email e senha corretamente';

      this.cdr.detectChanges();

      return;

    }

    if (!this.captchaToken) {

      this.errorMessage =
        'Confirme que você é humano';

      this.cdr.detectChanges();

      return;

    }

    this.loading = true;

    this.errorMessage = '';

    this.cdr.detectChanges();

    const payload: LoginRequest = {

      email: this.form.value.email,

      password: this.form.value.password

    };

    this.authService
      .authenticate(payload)
      .pipe(

        finalize(() => {

          this.loading = false;

          this.cdr.detectChanges();

        })

      )
      .subscribe({

        next: (response: any) => {

          const token =
            response.token ||
            response.accessToken ||
            response.jwt;

          if (token) {

            this.authService.saveToken(
              token
            );

            console.log('TOKEN SALVO:', localStorage.getItem('token'));

            this.router.navigate([
              '/dashboard'
            ]);

          } else {

            this.errorMessage =
              'Token não retornado pela API';

          }

          this.cdr.detectChanges();

        },

        error: (
          error: HttpErrorResponse
        ) => {

          console.error(error);

          if (error.status === 401) {

            this.errorMessage =
              'Email ou senha inválidos';

          } else if (
            error.status === 0
          ) {

            this.errorMessage =
              'Servidor indisponível';

          } else {

            this.errorMessage =
              'Erro ao realizar login';

          }

          this.cdr.detectChanges();

        }

      });

  }

}